/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AddIndividualRouteImport } from './routes/add-individual'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginBankidRouteImport } from './routes/login/bankid'
import { Route as AuthenticatedTimelineRouteImport } from './routes/_authenticated/timeline'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedServicesRouteImport } from './routes/_authenticated/services'
import { Route as AuthenticatedNotesRouteImport } from './routes/_authenticated/notes'
import { Route as AuthenticatedIndividualRouteImport } from './routes/_authenticated/individual'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedErrandsRouteImport } from './routes/_authenticated/errands'
import { Route as AuthenticatedDocumentsRouteImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedConversationsRouteImport } from './routes/_authenticated/conversations'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedNotesIndexRouteImport } from './routes/_authenticated/notes.index'
import { Route as AuthenticatedErrandsIndexRouteImport } from './routes/_authenticated/errands.index'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents.index'
import { Route as AuthenticatedContactsIndexRouteImport } from './routes/_authenticated/contacts.index'
import { Route as AuthenticatedNotesNewRouteImport } from './routes/_authenticated/notes.new'
import { Route as AuthenticatedNotesNoteIdRouteImport } from './routes/_authenticated/notes.$noteId'
import { Route as AuthenticatedErrandsIdRouteImport } from './routes/_authenticated/errands.$id'
import { Route as AuthenticatedDocumentsUploadRouteImport } from './routes/_authenticated/documents.upload'
import { Route as AuthenticatedDocumentsCombineRouteImport } from './routes/_authenticated/documents.combine'
import { Route as AuthenticatedBillingDoneRouteImport } from './routes/_authenticated/billing.done'
import { Route as AuthenticateddeveloperDesignSystemRouteImport } from './routes/_authenticated/(developer)/design-system'
import { Route as AuthenticateddeveloperDebugRouteImport } from './routes/_authenticated/(developer)/debug'
import { Route as AuthenticateddeveloperAiChatRouteImport } from './routes/_authenticated/(developer)/ai-chat'
import { Route as AuthenticatedErrandsIdUploadRouteImport } from './routes/_authenticated/errands.$id_.upload'
import { Route as AuthenticatedErrandsIdNotesNewRouteImport } from './routes/_authenticated/errands.$id_.notes.new'
import { Route as AuthenticatedErrandsIdNotesNoteIdRouteImport } from './routes/_authenticated/errands.$id_.notes.$noteId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AddIndividualRoute = AddIndividualRouteImport.update({
  id: '/add-individual',
  path: '/add-individual',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const LoginBankidRoute = LoginBankidRouteImport.update({
  id: '/bankid',
  path: '/bankid',
  getParentRoute: () => LoginRoute,
} as any)
const AuthenticatedTimelineRoute = AuthenticatedTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedServicesRoute = AuthenticatedServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotesRoute = AuthenticatedNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedIndividualRoute = AuthenticatedIndividualRouteImport.update({
  id: '/individual',
  path: '/individual',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedErrandsRoute = AuthenticatedErrandsRouteImport.update({
  id: '/errands',
  path: '/errands',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentsRoute = AuthenticatedDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConversationsRoute =
  AuthenticatedConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotesIndexRoute = AuthenticatedNotesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedNotesRoute,
} as any)
const AuthenticatedErrandsIndexRoute =
  AuthenticatedErrandsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedErrandsRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedContactsIndexRoute =
  AuthenticatedContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContactsRoute,
  } as any)
const AuthenticatedNotesNewRoute = AuthenticatedNotesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedNotesRoute,
} as any)
const AuthenticatedNotesNoteIdRoute =
  AuthenticatedNotesNoteIdRouteImport.update({
    id: '/$noteId',
    path: '/$noteId',
    getParentRoute: () => AuthenticatedNotesRoute,
  } as any)
const AuthenticatedErrandsIdRoute = AuthenticatedErrandsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedErrandsRoute,
} as any)
const AuthenticatedDocumentsUploadRoute =
  AuthenticatedDocumentsUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedDocumentsCombineRoute =
  AuthenticatedDocumentsCombineRouteImport.update({
    id: '/combine',
    path: '/combine',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedBillingDoneRoute =
  AuthenticatedBillingDoneRouteImport.update({
    id: '/billing/done',
    path: '/billing/done',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperDesignSystemRoute =
  AuthenticateddeveloperDesignSystemRouteImport.update({
    id: '/(developer)/design-system',
    path: '/design-system',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperDebugRoute =
  AuthenticateddeveloperDebugRouteImport.update({
    id: '/(developer)/debug',
    path: '/debug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperAiChatRoute =
  AuthenticateddeveloperAiChatRouteImport.update({
    id: '/(developer)/ai-chat',
    path: '/ai-chat',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedErrandsIdUploadRoute =
  AuthenticatedErrandsIdUploadRouteImport.update({
    id: '/$id_/upload',
    path: '/$id/upload',
    getParentRoute: () => AuthenticatedErrandsRoute,
  } as any)
const AuthenticatedErrandsIdNotesNewRoute =
  AuthenticatedErrandsIdNotesNewRouteImport.update({
    id: '/$id_/notes/new',
    path: '/$id/notes/new',
    getParentRoute: () => AuthenticatedErrandsRoute,
  } as any)
const AuthenticatedErrandsIdNotesNoteIdRoute =
  AuthenticatedErrandsIdNotesNoteIdRouteImport.update({
    id: '/$id_/notes/$noteId',
    path: '/$id/notes/$noteId',
    getParentRoute: () => AuthenticatedErrandsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/add-individual': typeof AddIndividualRoute
  '/login': typeof LoginRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/contacts': typeof AuthenticatedContactsRouteWithChildren
  '/conversations': typeof AuthenticatedConversationsRoute
  '/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/errands': typeof AuthenticatedErrandsRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/individual': typeof AuthenticatedIndividualRoute
  '/notes': typeof AuthenticatedNotesRouteWithChildren
  '/services': typeof AuthenticatedServicesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/timeline': typeof AuthenticatedTimelineRoute
  '/login/bankid': typeof LoginBankidRoute
  '/login/': typeof LoginIndexRoute
  '/ai-chat': typeof AuthenticateddeveloperAiChatRoute
  '/debug': typeof AuthenticateddeveloperDebugRoute
  '/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/billing/done': typeof AuthenticatedBillingDoneRoute
  '/documents/combine': typeof AuthenticatedDocumentsCombineRoute
  '/documents/upload': typeof AuthenticatedDocumentsUploadRoute
  '/errands/$id': typeof AuthenticatedErrandsIdRoute
  '/notes/$noteId': typeof AuthenticatedNotesNoteIdRoute
  '/notes/new': typeof AuthenticatedNotesNewRoute
  '/contacts/': typeof AuthenticatedContactsIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/errands/': typeof AuthenticatedErrandsIndexRoute
  '/notes/': typeof AuthenticatedNotesIndexRoute
  '/errands/$id/upload': typeof AuthenticatedErrandsIdUploadRoute
  '/errands/$id/notes/$noteId': typeof AuthenticatedErrandsIdNotesNoteIdRoute
  '/errands/$id/notes/new': typeof AuthenticatedErrandsIdNotesNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/add-individual': typeof AddIndividualRoute
  '/onboarding': typeof OnboardingRoute
  '/conversations': typeof AuthenticatedConversationsRoute
  '/home': typeof AuthenticatedHomeRoute
  '/individual': typeof AuthenticatedIndividualRoute
  '/services': typeof AuthenticatedServicesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/timeline': typeof AuthenticatedTimelineRoute
  '/login/bankid': typeof LoginBankidRoute
  '/login': typeof LoginIndexRoute
  '/ai-chat': typeof AuthenticateddeveloperAiChatRoute
  '/debug': typeof AuthenticateddeveloperDebugRoute
  '/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/billing/done': typeof AuthenticatedBillingDoneRoute
  '/documents/combine': typeof AuthenticatedDocumentsCombineRoute
  '/documents/upload': typeof AuthenticatedDocumentsUploadRoute
  '/errands/$id': typeof AuthenticatedErrandsIdRoute
  '/notes/$noteId': typeof AuthenticatedNotesNoteIdRoute
  '/notes/new': typeof AuthenticatedNotesNewRoute
  '/contacts': typeof AuthenticatedContactsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/errands': typeof AuthenticatedErrandsIndexRoute
  '/notes': typeof AuthenticatedNotesIndexRoute
  '/errands/$id/upload': typeof AuthenticatedErrandsIdUploadRoute
  '/errands/$id/notes/$noteId': typeof AuthenticatedErrandsIdNotesNoteIdRoute
  '/errands/$id/notes/new': typeof AuthenticatedErrandsIdNotesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/add-individual': typeof AddIndividualRoute
  '/login': typeof LoginRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/_authenticated/contacts': typeof AuthenticatedContactsRouteWithChildren
  '/_authenticated/conversations': typeof AuthenticatedConversationsRoute
  '/_authenticated/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/_authenticated/errands': typeof AuthenticatedErrandsRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/individual': typeof AuthenticatedIndividualRoute
  '/_authenticated/notes': typeof AuthenticatedNotesRouteWithChildren
  '/_authenticated/services': typeof AuthenticatedServicesRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/timeline': typeof AuthenticatedTimelineRoute
  '/login/bankid': typeof LoginBankidRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/(developer)/ai-chat': typeof AuthenticateddeveloperAiChatRoute
  '/_authenticated/(developer)/debug': typeof AuthenticateddeveloperDebugRoute
  '/_authenticated/(developer)/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/_authenticated/billing/done': typeof AuthenticatedBillingDoneRoute
  '/_authenticated/documents/combine': typeof AuthenticatedDocumentsCombineRoute
  '/_authenticated/documents/upload': typeof AuthenticatedDocumentsUploadRoute
  '/_authenticated/errands/$id': typeof AuthenticatedErrandsIdRoute
  '/_authenticated/notes/$noteId': typeof AuthenticatedNotesNoteIdRoute
  '/_authenticated/notes/new': typeof AuthenticatedNotesNewRoute
  '/_authenticated/contacts/': typeof AuthenticatedContactsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/errands/': typeof AuthenticatedErrandsIndexRoute
  '/_authenticated/notes/': typeof AuthenticatedNotesIndexRoute
  '/_authenticated/errands/$id_/upload': typeof AuthenticatedErrandsIdUploadRoute
  '/_authenticated/errands/$id_/notes/$noteId': typeof AuthenticatedErrandsIdNotesNoteIdRoute
  '/_authenticated/errands/$id_/notes/new': typeof AuthenticatedErrandsIdNotesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/add-individual'
    | '/login'
    | '/onboarding'
    | '/contacts'
    | '/conversations'
    | '/documents'
    | '/errands'
    | '/home'
    | '/individual'
    | '/notes'
    | '/services'
    | '/settings'
    | '/timeline'
    | '/login/bankid'
    | '/login/'
    | '/ai-chat'
    | '/debug'
    | '/design-system'
    | '/billing/done'
    | '/documents/combine'
    | '/documents/upload'
    | '/errands/$id'
    | '/notes/$noteId'
    | '/notes/new'
    | '/contacts/'
    | '/documents/'
    | '/errands/'
    | '/notes/'
    | '/errands/$id/upload'
    | '/errands/$id/notes/$noteId'
    | '/errands/$id/notes/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/add-individual'
    | '/onboarding'
    | '/conversations'
    | '/home'
    | '/individual'
    | '/services'
    | '/settings'
    | '/timeline'
    | '/login/bankid'
    | '/login'
    | '/ai-chat'
    | '/debug'
    | '/design-system'
    | '/billing/done'
    | '/documents/combine'
    | '/documents/upload'
    | '/errands/$id'
    | '/notes/$noteId'
    | '/notes/new'
    | '/contacts'
    | '/documents'
    | '/errands'
    | '/notes'
    | '/errands/$id/upload'
    | '/errands/$id/notes/$noteId'
    | '/errands/$id/notes/new'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/add-individual'
    | '/login'
    | '/onboarding'
    | '/_authenticated/contacts'
    | '/_authenticated/conversations'
    | '/_authenticated/documents'
    | '/_authenticated/errands'
    | '/_authenticated/home'
    | '/_authenticated/individual'
    | '/_authenticated/notes'
    | '/_authenticated/services'
    | '/_authenticated/settings'
    | '/_authenticated/timeline'
    | '/login/bankid'
    | '/login/'
    | '/_authenticated/(developer)/ai-chat'
    | '/_authenticated/(developer)/debug'
    | '/_authenticated/(developer)/design-system'
    | '/_authenticated/billing/done'
    | '/_authenticated/documents/combine'
    | '/_authenticated/documents/upload'
    | '/_authenticated/errands/$id'
    | '/_authenticated/notes/$noteId'
    | '/_authenticated/notes/new'
    | '/_authenticated/contacts/'
    | '/_authenticated/documents/'
    | '/_authenticated/errands/'
    | '/_authenticated/notes/'
    | '/_authenticated/errands/$id_/upload'
    | '/_authenticated/errands/$id_/notes/$noteId'
    | '/_authenticated/errands/$id_/notes/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AddIndividualRoute: typeof AddIndividualRoute
  LoginRoute: typeof LoginRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/add-individual': {
      id: '/add-individual'
      path: '/add-individual'
      fullPath: '/add-individual'
      preLoaderRoute: typeof AddIndividualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/bankid': {
      id: '/login/bankid'
      path: '/bankid'
      fullPath: '/login/bankid'
      preLoaderRoute: typeof LoginBankidRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_authenticated/timeline': {
      id: '/_authenticated/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof AuthenticatedTimelineRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/services': {
      id: '/_authenticated/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AuthenticatedServicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notes': {
      id: '/_authenticated/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AuthenticatedNotesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual': {
      id: '/_authenticated/individual'
      path: '/individual'
      fullPath: '/individual'
      preLoaderRoute: typeof AuthenticatedIndividualRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/errands': {
      id: '/_authenticated/errands'
      path: '/errands'
      fullPath: '/errands'
      preLoaderRoute: typeof AuthenticatedErrandsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations': {
      id: '/_authenticated/conversations'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof AuthenticatedConversationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notes/': {
      id: '/_authenticated/notes/'
      path: '/'
      fullPath: '/notes/'
      preLoaderRoute: typeof AuthenticatedNotesIndexRouteImport
      parentRoute: typeof AuthenticatedNotesRoute
    }
    '/_authenticated/errands/': {
      id: '/_authenticated/errands/'
      path: '/'
      fullPath: '/errands/'
      preLoaderRoute: typeof AuthenticatedErrandsIndexRouteImport
      parentRoute: typeof AuthenticatedErrandsRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/contacts/': {
      id: '/_authenticated/contacts/'
      path: '/'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthenticatedContactsIndexRouteImport
      parentRoute: typeof AuthenticatedContactsRoute
    }
    '/_authenticated/notes/new': {
      id: '/_authenticated/notes/new'
      path: '/new'
      fullPath: '/notes/new'
      preLoaderRoute: typeof AuthenticatedNotesNewRouteImport
      parentRoute: typeof AuthenticatedNotesRoute
    }
    '/_authenticated/notes/$noteId': {
      id: '/_authenticated/notes/$noteId'
      path: '/$noteId'
      fullPath: '/notes/$noteId'
      preLoaderRoute: typeof AuthenticatedNotesNoteIdRouteImport
      parentRoute: typeof AuthenticatedNotesRoute
    }
    '/_authenticated/errands/$id': {
      id: '/_authenticated/errands/$id'
      path: '/$id'
      fullPath: '/errands/$id'
      preLoaderRoute: typeof AuthenticatedErrandsIdRouteImport
      parentRoute: typeof AuthenticatedErrandsRoute
    }
    '/_authenticated/documents/upload': {
      id: '/_authenticated/documents/upload'
      path: '/upload'
      fullPath: '/documents/upload'
      preLoaderRoute: typeof AuthenticatedDocumentsUploadRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/documents/combine': {
      id: '/_authenticated/documents/combine'
      path: '/combine'
      fullPath: '/documents/combine'
      preLoaderRoute: typeof AuthenticatedDocumentsCombineRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/billing/done': {
      id: '/_authenticated/billing/done'
      path: '/billing/done'
      fullPath: '/billing/done'
      preLoaderRoute: typeof AuthenticatedBillingDoneRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/design-system': {
      id: '/_authenticated/(developer)/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AuthenticateddeveloperDesignSystemRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/debug': {
      id: '/_authenticated/(developer)/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof AuthenticateddeveloperDebugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/ai-chat': {
      id: '/_authenticated/(developer)/ai-chat'
      path: '/ai-chat'
      fullPath: '/ai-chat'
      preLoaderRoute: typeof AuthenticateddeveloperAiChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/errands/$id_/upload': {
      id: '/_authenticated/errands/$id_/upload'
      path: '/$id/upload'
      fullPath: '/errands/$id/upload'
      preLoaderRoute: typeof AuthenticatedErrandsIdUploadRouteImport
      parentRoute: typeof AuthenticatedErrandsRoute
    }
    '/_authenticated/errands/$id_/notes/new': {
      id: '/_authenticated/errands/$id_/notes/new'
      path: '/$id/notes/new'
      fullPath: '/errands/$id/notes/new'
      preLoaderRoute: typeof AuthenticatedErrandsIdNotesNewRouteImport
      parentRoute: typeof AuthenticatedErrandsRoute
    }
    '/_authenticated/errands/$id_/notes/$noteId': {
      id: '/_authenticated/errands/$id_/notes/$noteId'
      path: '/$id/notes/$noteId'
      fullPath: '/errands/$id/notes/$noteId'
      preLoaderRoute: typeof AuthenticatedErrandsIdNotesNoteIdRouteImport
      parentRoute: typeof AuthenticatedErrandsRoute
    }
  }
}

interface AuthenticatedContactsRouteChildren {
  AuthenticatedContactsIndexRoute: typeof AuthenticatedContactsIndexRoute
}

const AuthenticatedContactsRouteChildren: AuthenticatedContactsRouteChildren = {
  AuthenticatedContactsIndexRoute: AuthenticatedContactsIndexRoute,
}

const AuthenticatedContactsRouteWithChildren =
  AuthenticatedContactsRoute._addFileChildren(
    AuthenticatedContactsRouteChildren,
  )

interface AuthenticatedDocumentsRouteChildren {
  AuthenticatedDocumentsCombineRoute: typeof AuthenticatedDocumentsCombineRoute
  AuthenticatedDocumentsUploadRoute: typeof AuthenticatedDocumentsUploadRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
}

const AuthenticatedDocumentsRouteChildren: AuthenticatedDocumentsRouteChildren =
  {
    AuthenticatedDocumentsCombineRoute: AuthenticatedDocumentsCombineRoute,
    AuthenticatedDocumentsUploadRoute: AuthenticatedDocumentsUploadRoute,
    AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  }

const AuthenticatedDocumentsRouteWithChildren =
  AuthenticatedDocumentsRoute._addFileChildren(
    AuthenticatedDocumentsRouteChildren,
  )

interface AuthenticatedErrandsRouteChildren {
  AuthenticatedErrandsIdRoute: typeof AuthenticatedErrandsIdRoute
  AuthenticatedErrandsIndexRoute: typeof AuthenticatedErrandsIndexRoute
  AuthenticatedErrandsIdUploadRoute: typeof AuthenticatedErrandsIdUploadRoute
  AuthenticatedErrandsIdNotesNoteIdRoute: typeof AuthenticatedErrandsIdNotesNoteIdRoute
  AuthenticatedErrandsIdNotesNewRoute: typeof AuthenticatedErrandsIdNotesNewRoute
}

const AuthenticatedErrandsRouteChildren: AuthenticatedErrandsRouteChildren = {
  AuthenticatedErrandsIdRoute: AuthenticatedErrandsIdRoute,
  AuthenticatedErrandsIndexRoute: AuthenticatedErrandsIndexRoute,
  AuthenticatedErrandsIdUploadRoute: AuthenticatedErrandsIdUploadRoute,
  AuthenticatedErrandsIdNotesNoteIdRoute:
    AuthenticatedErrandsIdNotesNoteIdRoute,
  AuthenticatedErrandsIdNotesNewRoute: AuthenticatedErrandsIdNotesNewRoute,
}

const AuthenticatedErrandsRouteWithChildren =
  AuthenticatedErrandsRoute._addFileChildren(AuthenticatedErrandsRouteChildren)

interface AuthenticatedNotesRouteChildren {
  AuthenticatedNotesNoteIdRoute: typeof AuthenticatedNotesNoteIdRoute
  AuthenticatedNotesNewRoute: typeof AuthenticatedNotesNewRoute
  AuthenticatedNotesIndexRoute: typeof AuthenticatedNotesIndexRoute
}

const AuthenticatedNotesRouteChildren: AuthenticatedNotesRouteChildren = {
  AuthenticatedNotesNoteIdRoute: AuthenticatedNotesNoteIdRoute,
  AuthenticatedNotesNewRoute: AuthenticatedNotesNewRoute,
  AuthenticatedNotesIndexRoute: AuthenticatedNotesIndexRoute,
}

const AuthenticatedNotesRouteWithChildren =
  AuthenticatedNotesRoute._addFileChildren(AuthenticatedNotesRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedContactsRoute: typeof AuthenticatedContactsRouteWithChildren
  AuthenticatedConversationsRoute: typeof AuthenticatedConversationsRoute
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRouteWithChildren
  AuthenticatedErrandsRoute: typeof AuthenticatedErrandsRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedIndividualRoute: typeof AuthenticatedIndividualRoute
  AuthenticatedNotesRoute: typeof AuthenticatedNotesRouteWithChildren
  AuthenticatedServicesRoute: typeof AuthenticatedServicesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedTimelineRoute: typeof AuthenticatedTimelineRoute
  AuthenticateddeveloperAiChatRoute: typeof AuthenticateddeveloperAiChatRoute
  AuthenticateddeveloperDebugRoute: typeof AuthenticateddeveloperDebugRoute
  AuthenticateddeveloperDesignSystemRoute: typeof AuthenticateddeveloperDesignSystemRoute
  AuthenticatedBillingDoneRoute: typeof AuthenticatedBillingDoneRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedContactsRoute: AuthenticatedContactsRouteWithChildren,
  AuthenticatedConversationsRoute: AuthenticatedConversationsRoute,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRouteWithChildren,
  AuthenticatedErrandsRoute: AuthenticatedErrandsRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedIndividualRoute: AuthenticatedIndividualRoute,
  AuthenticatedNotesRoute: AuthenticatedNotesRouteWithChildren,
  AuthenticatedServicesRoute: AuthenticatedServicesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedTimelineRoute: AuthenticatedTimelineRoute,
  AuthenticateddeveloperAiChatRoute: AuthenticateddeveloperAiChatRoute,
  AuthenticateddeveloperDebugRoute: AuthenticateddeveloperDebugRoute,
  AuthenticateddeveloperDesignSystemRoute:
    AuthenticateddeveloperDesignSystemRoute,
  AuthenticatedBillingDoneRoute: AuthenticatedBillingDoneRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface LoginRouteChildren {
  LoginBankidRoute: typeof LoginBankidRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginBankidRoute: LoginBankidRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AddIndividualRoute: AddIndividualRoute,
  LoginRoute: LoginRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
